/*=========================================================================================
  File Name: moduleAuthState.js
  Description: Auth Module State
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import { getAuthInstance } from '@/auth/authService'

export default {
  isUserLoggedIn: () => {
    let isAuthenticated = false

    isAuthenticated = !!getAuthInstance().isAuthenticated;

    return isAuthenticated
  },
  accessToken: null,
  user: null,
  accessDenied: true,
  passwordExpired: false,
}
